var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85271 0.370538C6.91341 0.429474 6.96464 0.493409 7.00919 0.560675L11.6598 5.06065C12.1133 5.49965 12.1135 6.21188 11.6596 6.65109C11.2059 7.0903 10.47 7.0903 10.0158 6.65109L6.01049 2.77567L1.98427 6.67108C1.53055 7.11029 0.79487 7.11029 0.340504 6.67108C0.113214 6.45137 -2.65897e-07 6.16335 -2.53412e-07 5.87596C-2.40926e-07 5.58857 0.113214 5.30035 0.340504 5.08085L5.01265 0.560675C5.05721 0.493409 5.10843 0.429058 5.16913 0.370538C5.40116 0.14604 5.70679 0.0377472 6.01092 0.0431618C6.31505 0.0377472 6.62047 0.14604 6.85271 0.370538Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrowUpIcon.1e0a27093964b77614acc66a41f4d0a0.svg";
export { ForwardRef as ReactComponent };